import React from 'react'
import { FormGroup, ControlLabel, FormControl } from 'react-bootstrap'
import VirtualizedSelect from 'react-virtualized-select'
import 'react-select/dist/react-select.css'
import 'react-virtualized-select/styles.css'

function AddCoach(props) {
  const {
    coachSelectOptions,
    selectedCoachValues,
    handleCoachSelectionChange,
    disabled,
  } = props

  const options = coachSelectOptions || []
  const selectedValue = (selectedCoachValues || [])
    .map((value) => options.find((option) => option.value === value))
    .filter(Boolean)

  return (
    <div>
      <h3>Coaches</h3>
      <FormGroup>
        <ControlLabel>Coach Name</ControlLabel>
        <VirtualizedSelect
          className="udf-multi-select opaque-grey"
          name="head_coach"
          value={selectedValue}
          options={options}
          multi={true}
          onChange={(choices) => handleCoachSelectionChange(choices)}
          placeholder="---"
          disabled={disabled}
        />
        <FormControl
          className="opaque-grey"
          name="head_coach"
          id="head_coach"
          value={selectedCoachValues && selectedCoachValues[0] ? selectedCoachValues[0] : ''}
          type="hidden"
          readOnly
          disabled={disabled}
        />
      </FormGroup>
    </div>
  )
}

export default AddCoach
